function getVersionBySdk(focusSDK: any) {
  const appInfo = focusSDK.appInfo;
  if (appInfo?.version) {
    return appInfo.version || "";
  }
  if (appInfo && typeof appInfo === "function") {
    // @ts-ignore
    const res = appInfo();
    const { version = "", releaseAlias = "" } = res || {};
    return version.replace(`${releaseAlias ? `-${releaseAlias}` : ""}`, "");
  }
  return "";
}

/**
 * 获取版本信息
 * @param focusSDK
 * @returns
 */
export function getVersionInfo(focusSDK: any) {
  const appInfo = focusSDK.appInfo;
  let res;
  if (appInfo && typeof appInfo === "function") {
    // @ts-ignore
    res = appInfo();
  } else if (appInfo && typeof appInfo === "object") {
    res = appInfo;
  }
  if (res?.buildVersion) {
    res.buildVersion = res.buildVersion.replace(/\D/g, "/");
  }
  return res || {};
}

export function getAppVersion(focusSDK: any) {
  if (focusSDK.getDeviceInfo().platform === "web") {
    return focusSDK.getVersion();
  }
  return getVersionBySdk(focusSDK);
}

export default getVersionBySdk;
